module.exports = __webpack_public_path__ + "static/img/no-img.4308a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/no-img.png
// module id = EIPB
// module chunks = 2